import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const SubmitFilters = (props) => {

  function handleSubmit(e) {
    e.preventDefault()
    props.onSubmit()
  }

  return (
    <div className="c-projects-submit-filters">
      <button onClick={handleSubmit} className="c-button c-button--primary">Toepassen</button>
    </div>
  )
}

export default SubmitFilters



// WEBPACK FOOTER //
// ./src/js/projects/components/SubmitFilters.js